<template>
  <iText
    v-if="editMode || stateLabel"
    :font-size="getOptionValue(FontSize)"
    :variant="stateVariant"
  >
    {{ stateLabel || placeholderLabel }}
  </iText>
</template>

<script>
import { BaseStoryCardElementMixin } from "%/dynamic-component-editor/standard-components/base-story-card/base-story-card-element-mixin";
import FontSize from "%/dynamic-component-editor/options/font-size";
const STATE_WAITING = "waiting";
const STATE_REMOVED = "removed";

const LABEL_BY_STATE = {
  [STATE_WAITING]: "Waiting for approval — only you and the moderators can see this.",
  [STATE_REMOVED]: "Removed — only you and the moderators can see this.",
};

export default {
  name: "ModerationStateBadge",
  elementPanelSettings: {
    displayName: "Moderation State",
    displayIcon: "info-circle",
    elementType: "element",
    elementGroup: "storyElements",
  },
  mixins: [BaseStoryCardElementMixin],
  data() {
    return {
      FontSize,
    };
  },
  computed: {
    placeholderLabel() {
      return LABEL_BY_STATE[STATE_WAITING];
    },
    stateLabel() {
      return LABEL_BY_STATE[this.entity?.viewerState] ?? "";
    },
    stateVariant() {
      return this.entity?.viewerState === STATE_REMOVED ? "error" : "subtle";
    },
  },
};
</script>
